export default __webpack_public_path__ + "static/media/parcel-relay.0fa46a12.svg";